import LegalNameCheckoutPage from "@faire/prototype-playground/workspace/bl/legal-name-checkout";
import StarterPrototypePage from "@faire/prototype-playground/workspace/bl/starter-prototype";
import { Route, Switch } from "react-router-dom";

export function BellaLuRoutes() {
  return (
    <Switch>
      <Route path="/bl/legal-name-checkout" component={LegalNameCheckoutPage} />
      <Route path="/bl/starter-prototype" component={StarterPrototypePage} />
    </Switch>
  );
}

export const slug = "bl";
